import { EnJoue } from "./EnJoue.js";
import { Pan } from "./Pan.js";
import { DoubleViseur } from "./DoubleViseur.js";
import { TireurDelite } from "./TireurDelite.js";
import { RectifierTirDroite } from "./RectifierTirDroite.js";
import { RectifierTirGauche } from "./RectifierTirGauche.js";
import { PalmeArriere } from "./PalmeArriere.js";
import { PalmeAvant } from "./PalmeAvant.js";
import { EnAvantMarche } from "./EnAvantMarche.js";
import { Canardage } from "./Canardage.js";
import { Banzai } from "./Banzai.js";
import { Dispertion } from "./Dispertion.js";
import { Planque } from "./Planque.js";

/**
 * Map typeId -> card class.
 * Used by decksBuilder for deck creation.
 */
export const CARD_CLASS_MAP = {
    EN_JOUE: EnJoue,
    PAN: Pan,
    DOUBLE_VISEUR: DoubleViseur,
    TIREUR_DELITE: TireurDelite,
    RECTIFIER_TIR_DROITE: RectifierTirDroite,
    RECTIFIER_TIR_GAUCHE: RectifierTirGauche,
    PALME_ARRIERE: PalmeArriere,
    PALME_AVANT: PalmeAvant,
    EN_AVANT_MARCHE: EnAvantMarche,
    CANARDAGE: Canardage,
    BANZAI: Banzai,
    DISPERTION: Dispertion,
    PLANQUE: Planque,
};

export {
    EnJoue,
    Pan,
    DoubleViseur,
    TireurDelite,
    RectifierTirDroite,
    RectifierTirGauche,
    PalmeArriere,
    PalmeAvant,
    EnAvantMarche,
    Canardage,
    Banzai,
    Dispertion,
    Planque,
};
